import React from 'react';
import { useFooterSafeBottom } from '../../hooks/useFooterSafeBottom';

interface BarcodeScannerFabProps {
  onClick: () => void;
  disabled?: boolean;
  queuedCount?: number;
  buttonRef?: React.Ref<HTMLButtonElement>;
}

/**
 * Floating launcher for the home barcode scanner. Shared by HomePage (shown
 * while the scanner chunk loads) and HomeBarcodeScannerWidget so both render
 * the identical bubble and stay clear of the footer like the chat bubble.
 */
export default function BarcodeScannerFab({ onClick, disabled = false, queuedCount = 0, buttonRef }: BarcodeScannerFabProps) {
  const safeBottom = useFooterSafeBottom();
  return (
    <button
      ref={buttonRef}
      type="button"
      className="home-barcode-widget__fab"
      style={{ '--home-barcode-fab-bottom': `${safeBottom}px` } as React.CSSProperties}
      onClick={onClick}
      disabled={disabled}
      aria-label="Open inventory scanner"
    >
      <span className="home-barcode-widget__fab-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none">
          <path d="M4 7V5h3M20 7V5h-3M4 17v2h3M20 17v2h-3M7 9v6M10 8v8M13 9v6M16 8v8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </span>
      {queuedCount > 0 ? <span className="home-barcode-widget__fab-count">{queuedCount}</span> : null}
    </button>
  );
}
